export const useSelectSkill = (arrow: any, theme: any): any => {
    let styles: any = {
        menu: (provided: any) => ({
            ...provided,
            zIndex: "20 !important"
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            fontSize: "0.875rem",
            fontWeight: "400",
            color: state.isSelected ? "#4E566D" : state.isFocused ? "#686868" : "#686868",
            backgroundColor: state.isSelected ? "#EDEDED" : state.isFocused ? "#EDEDED" : "#fff",
            border: "none",
            borderRadius: state.isFocused && "8px",
            "&:hover": {
                backgroundColor: state.isDisabled ? "normal" : "#EDEDED",
                border: "none",
                borderRadius: "8px",
                color: state.isSelected ? "#4E566D" : state.isFocused ? "#686868" : state.isDisabled ? "#686868" : "#686868",
            },
            padding: "6px 12px",
            cursor: "pointer"
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            color: `${theme === "dark" ? "#AFB2BC" : "#4E566D"}`,
            fontSize: "0.875rem",
            fontWeight: "400",
        }),
        dropdownIndicator: (provided: any, state: any) => ({
            ...provided,
            color: state.isFocused ? "#4B5563" : "#4B5563",
            fontSize: "0.875rem",
            fontWeight: "400",
            "&:hover": {
                color: state.isFocused ? "#4B5563" : "#4B5563",
            },
            padding: "0.625rem 0.75rem",
            display: arrow ? "block" : "none",
        }),
        indicatorSeparator: (provided: any, state: any) => ({
            ...provided,
            display: "none",
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            border: state.isFocused ? `${theme === "dark" ? "1px solid #454545" : "1px solid #D7D8DD"}` : `${theme === "dark" ? "1px solid #454545" : "1px solid #D7D8DD"}`,
            backgroundColor: state.isFocused ? `${theme === "dark" ? "#2a2c38" : "#fff"}` : `${theme === "dark" ? "#3c3a35" : "#F5F5F5"}`,
            borderRadius: state.isFocused ? "6px" : "6px",
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                backgroundColor: `${theme === "dark" ? "#2a2c38" : "#fff"}`,
            },
            cursor: !arrow ? "text" : "pointer",
            minHeight: '40px',
        }),
        input: (provided: any, state: any) => ({
            ...provided,
            color: `${theme === "dark" ? "#AFB2BC" : "#4E566D"}`,
            fontSize: "0.875rem",
            fontWeight: "400",
            cursor: "text"
        }),
        placeholder: (provided: any, state: any) => ({
            ...provided,
            color: `${theme === "dark" ? "#AFB2BC" : "#4E566D"}`,
            fontSize: "0.875rem",
            fontWeight: "400",
        }),
        multiValue: (provided: any, state: any) => ({
            ...provided,
            background: `${theme === "dark" ? "#2A2C38" : "#ECF6FF"}`,
            border: "1px solid #059DB2",
            borderRadius: "20px",
            height: "25px",
            display: "flex",
            alignItems: "center"
        }),
        multiValueLabel: (provided: any, state: any) => ({
            ...provided,
            color: `${theme === "dark" ? "#AFB2BC" : "#4E566D"}`,
            lineHeight: '19px'
        }),
        multiValueRemove: (provided: any, state: any) => ({
            ...provided,
            borderRadius: "20px",
            "&:hover": {
                borderRadius: "20px",
            },
            color: `${theme === "dark" ? "#AFB2BC" : "#4E566D"}`,
            padding: "2px"
        })
    };

    return styles;
};